import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-validation-message',
  templateUrl: './validation-message.component.html',
  styleUrls: ['./validation-message.component.scss']
})
export class ValidationMessageComponent {
  @Input() messages: string[] = [];
  @Input() title = 'Complete Required Details';
  @Input() dismissible = true;
  @Output() dismissed = new EventEmitter<void>();

  closeMessage(): void {
    this.dismissed.emit();
  }
}
